module.exports = __webpack_public_path__ + "static/img/qyfy.66e1a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyfy.jpg
// module id = kBTb
// module chunks = 73